import {
  UPPER_TOOTH_DESIGN,
  type UpperArchSettings,
} from '@witmetrics/unison-core';

export const STEPS = {
  SELECT_MOUTH: 'SELECT_MOUTH',
  PLACE_TEETH: 'PLACE_TEETH',
} as const;

export const DEFAULT_SETTINGS: UpperArchSettings = {
  toothDesign: UPPER_TOOTH_DESIGN.OVAL,
  archShape: 1,
  embrasures: true,
};
